export default "__VITE_ASSET__BhNmURDy__";